import type { TargetRef } from "../SettingsPayload";

/**
 * 書き込まない対象を `targets` の部分集合へ絞る。
 *
 * 型の約束は「`skipTargets` は `targets` の部分集合」だが、本文を書き替えると `targets` は
 * メンションから作り直されるため、外れた ref が旗に残る。残ったまま貼り直すと、その対象は
 * 外れた状態で現れ、利用者は書き込まれない理由が分からない。**約束は書き込む側で守る。**
 *
 * 空になったら `undefined` を返す。空配列を保存すると「指定が無い」と「全部書き込む」が
 * ファイル上で区別できなくなる。
 */
export function narrowSkipTargets(
    skipTargets: readonly TargetRef[] | undefined,
    targets: readonly TargetRef[]
): TargetRef[] | undefined {
    if (skipTargets === undefined || skipTargets.length === 0) return undefined;
    const kept = skipTargets.filter((ref) => targets.indexOf(ref) >= 0);
    return kept.length > 0 ? kept : undefined;
}
